import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/** One dashboard quick-action tile. Lived inside SalesOfficerDashboard until the
 *  manager dashboard needed the same "Add Visit" (§1 Fix A, 2026-09-07) — one
 *  component per fact, so the two dashboards cannot drift. */
export default function QuickAction({ to, Icon, label, helper, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group flex items-center gap-3 bg-callisto-navy text-white rounded-xl p-4 hover:bg-callisto-navy/90 transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
    >
      <div className="h-10 w-10 rounded-lg bg-callisto-gold text-callisto-navy flex items-center justify-center shrink-0">
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-bold">{label}</p>
        <p className="text-[11px] text-white/70 truncate">{helper}</p>
      </div>
      <ArrowUpRight className="ml-auto h-4 w-4 text-callisto-gold opacity-0 group-hover:opacity-100 transition-opacity" />
    </Link>
  );
}
